import React from "react";
import MaskedInput from "react-text-mask";

/* ================================
   Máscaras
================================ */

export const cpfMask = [
  /\d/, /\d/, /\d/, ".",
  /\d/, /\d/, /\d/, ".",
  /\d/, /\d/, /\d/, "-",
  /\d/, /\d/
];

export const cnpjMask = [
  /\d/, /\d/, ".",
  /\d/, /\d/, /\d/, ".",
  /\d/, /\d/, /\d/, "/",
  /\d/, /\d/, /\d/, /\d/, "-",
  /\d/, /\d/
];

export const phoneMask = [
  "(", /\d/, /\d/, ")", " ",
  /\d/, /\d/, /\d/, /\d/, /\d/,
  "-", /\d/, /\d/, /\d/, /\d/
];

export const cepMask = [
  /\d/, /\d/, /\d/, /\d/, /\d/,
  "-", /\d/, /\d/, /\d/
];

export const flexiblePhoneMask = (rawValue = "") => {
  const digits = String(rawValue).replace(/\D/g, "");
  const hasNinthDigit = digits.length > 10;

  return hasNinthDigit
    ? [
        "(", /\d/, /\d/, ")", " ",
        /\d/, " ", /\d/, /\d/, /\d/, /\d/,
        "-", /\d/, /\d/, /\d/, /\d/
      ]
    : [
        "(", /\d/, /\d/, ")", " ",
        /\d/, /\d/, /\d/, /\d/,
        "-", /\d/, /\d/, /\d/, /\d/
      ];
};


/* ================================
   Componente adaptador para MUI
================================ */

export const TextMaskCustom = React.forwardRef(function TextMaskCustom(
  props,
  ref
) {
  const { mask, ...other } = props;

  return (
    <MaskedInput
      {...other}
      mask={mask}
      guide={false}
      ref={(maskedInputRef) => {
        if (!maskedInputRef) return;

        const inputElement = maskedInputRef.inputElement;

        if (typeof ref === "function") {
          ref(inputElement);
        } else if (ref) {
          ref.current = inputElement;
        }
      }}
    />
  );
});
